import { env } from '@/env';
import { CR_PROFILE_TYPE } from '@/lib/limulo/code';
import { BACKGAMMON_PROFILE_TYPE } from '@/lib/qgammon/lobbyTornei';

/**
 * I sit&go di qTournaments nel pannello «Sit&Go» della Hub CR (Luca, L-2285): acceso SOLO col flag suo
 * (`VITE_FEATURE_TOURNAMENT_SITNGO_ENABLED`) in AND con quello delle code e con Limulo — il biglietto
 * vive in `CodeTorneiContext`, che monta solo con quei due.
 * 🔴 UN predicato, due lettori: `SitngoPanel` (quale pannello montare) e la barra della coda
 * (`AzionePersistente` → `BarraCoda`: dove nascondersi e dove porta «Vai»). Due copie divergerebbero,
 * e la barra porterebbe a un pannello che non c'e'.
 */
export function sitngoDiQtournamentsAcceso(): boolean {
  return (
    env.featureTournamentSitngoEnabled &&
    env.featureTournamentQueuesEnabled &&
    env.featureLimuloEnabled
  );
}

/**
 * I sit&go di qTournaments nella sezione «Sit&Go» del BACKGAMMON (Luca, I-334 punto 4; I-340: solo il Sit&Go con
 * «Entra/Esci» come CR, niente coda 1v1 Limulo per il BG): acceso SOLO col flag suo
 * (`VITE_FEATURE_TOURNAMENT_SITNGO_BACKGAMMON_ENABLED`) in AND con quello delle code, con Limulo e col backgammon
 * acceso nella build — il biglietto vive in `CodeTorneiContext`, che monta solo con code e Limulo.
 * 🔴 UN predicato, tre lettori: l'elenco delle schede (`lobbySections.ts`, Hub e `/backgammon` insieme), la ripresa
 * all'avvio e la barra della coda (`giochiConCodeDaRiprendere`, `AzionePersistente`). Due copie divergerebbero, e la
 * barra porterebbe a una scheda che non c'e'. Il ruolo `beta` non si ricontrolla qui: chi arriva alle schede del
 * backgammon l'ha gia' (`RoleGate` sulla rotta, `showQgammon` sulla Hub).
 */
export function sitngoBackgammonAcceso(): boolean {
  return (
    env.featureTournamentSitngoBackgammonEnabled &&
    env.featureTournamentQueuesEnabled &&
    env.featureLimuloEnabled &&
    env.featureBackgammonEnabled
  );
}

/**
 * I giochi (`profileType` del catalogo) di cui l'app RIPRENDE un'attesa all'avvio (`CodeTorneiContext`) e a cui la
 * barra della coda sa portare («Vai»): quelli che hanno un pannello delle code acceso in questa build. Clash Royale
 * da sempre; il backgammon solo col suo predicato (`sitngoBackgammonAcceso`). Ogni gioco che avra' il suo pannello
 * si aggiunge QUI, insieme al suo flag, e solo allora un biglietto di quel gioco si adotta e si rinnova da
 * qualunque schermata.
 */
export function giochiConCodeDaRiprendere(): readonly string[] {
  return sitngoBackgammonAcceso() ? [CR_PROFILE_TYPE, BACKGAMMON_PROFILE_TYPE] : [CR_PROFILE_TYPE];
}
